import { useState } from 'react'

import { faLink } from '@fortawesome/pro-light-svg-icons/faLink'
import Button from '@space-core/components/button'
import { Emoji } from '@space-core/components/emoji'
import EmojiPicker from '@space-core/components/emojiPicker'

import Label from '@space-core/components/form/label'
import Icon from '@space-core/components/icon'

import { EmojiUtils } from '@space-core/utils/emoji'

import styled from 'styled-components'

import { useCustomEmoji } from './useCustomEmoji'

type EmojiSelectProps = {
  onChange: (value: string) => void
  value?: string
  label?: string
  name?: string
}

const CustomButton = styled(Button)`
  border-color: var(--input-border-color) !important;
  max-height: 2.625rem;
`

const EmojiSelect = ({ label, onChange, value, name }: EmojiSelectProps) => {
  const custom = useCustomEmoji()
  const [showEmojiBox, setShowEmojiBox] = useState<boolean>(false)

  const handleToggleEmojiBox = () => setShowEmojiBox((current) => !current)
  const handleCloseEmojiBox = () => setShowEmojiBox(false)

  const handleSelectEmoji = (emojiData) => {
    const data = emojiData.unified
      ? EmojiUtils.convertUnifiedToNative(emojiData.unified)
      : emojiData.src

    onChange(data)
    handleCloseEmojiBox()
  }

  return (
    <div className='_mr-2'>
      {label && <Label htmlFor={name ?? 'emoji'}>{label}</Label>}

      <CustomButton variation='tertiary' className='_px-4 _py-2' onClick={handleToggleEmojiBox}>
        {value ? <Emoji id={value} /> : <Icon icon={faLink} />}
      </CustomButton>
      <EmojiPicker
        close={handleCloseEmojiBox}
        isOpen={showEmojiBox}
        handleSelectEmoji={handleSelectEmoji}
        name={name}
        custom={custom}
      />
    </div>
  )
}

export default EmojiSelect
